module.exports = __webpack_public_path__ + "media/images/redesign-images/contract/contract-sales-01-987ce742d919b4aab1a860859a5de29a.svg";